const fragment = `
  id
  isDefault
  package {
    id
    name
  }
`;

export const listModelPackagesQuery = `
  query ListModelPackages(
    $filter: ModelPackageFilterInput
  ) {
    items: listModelPackages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createModelPackageQuery = `
  mutation CreateModelPackage(
    $input: CreateModelPackageInput!
  ) {
    item: createModelPackage(input: $input) {
      ${fragment}
    }
  }
`;

export const updateModelPackageQuery = `
  mutation UpdateModelPackage(
    $input: UpdateModelPackageInput!
  ) {
    item: updateModelPackage(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteModelPackageQuery = `
  mutation DeleteModelPackage(
    $id: Int!
  ) {
    item: deleteModelPackage(id: $id) {
      ${fragment}
    }
  }
`;
